<script>
  import { createEventDispatcher } from "svelte";

  export let dark = false;

  const dispatch = createEventDispatcher();

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const animationDelay = getRandomInt(0, 3);

  function handleClick(event) {
    dispatch("click", event);
  }
</script>

<div class="target" class:target--dark={dark} on:click={handleClick}>
  <svg
    width="48"
    height="48"
    viewBox="0 0 16.933333 16.933333"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        class="target__border target__border-top--right"
        d="m 11.11313,0.27018317 h 5.55002 V 5.8202037"
      />
      <path
        class="target__border target__border-bottom--right"
        d="m 16.66875,11.211719 v 5.457031 h -5.457031 v 0"
      />
      <path
        class="target__border target__border-bottom--left"
        d="M 0.26458333,11.165639 V 16.66875 H 5.767694"
      />
      <path
        class="target__border target__border--top-left"
        d="M 0.26458333,5.6460244 V 0.26458333 H 5.6460245"
      />
      <circle class="target__circle" cx="8.4666662" cy="8.4666662" r="2" />
    </g>
  </svg>
</div>

<style lang="scss">
  @import "./assets/styles/variables";
  @import "./assets/styles/animations";

  .target {
    color: $color-blue;
    height: 48px;
    position: relative;
    transform: scale(0.8);
    transition: transform 0.05s ease-in, box-shadow 0.05s ease-in;
    width: 48px;

    &::before {
      background-color: currentColor;
      bottom: -2px;
      box-shadow: 0 0 1rem currentColor;
      content: "";
      left: -2px;
      opacity: 0.2;
      position: absolute;
      right: -2px;
      top: -2px;
      z-index: -1;
    }

    &:hover {
      transform: scale(1.1) !important;
    }

    &__border {
      fill: none;
      stroke: #ffffff;
      stroke-width: 1.5px;
      stroke-linecap: butt;
      stroke-linejoin: miter;
      stroke-miterlimit: 4;
      stroke-dasharray: none;
      stroke-opacity: 1;
    }

    /*&--dark::before {
      background-color: $color-orange-light;
    }*/

    /*&--dark &__border {
      stroke: #000000;
    }*/

    &__circle {
      fill: #ffffff;
      fill-opacity: 1;
      stroke: none;
    }

    /*&--dark &__circle {
      fill: #000000;
    }*/
  }
</style>
